import { SIDEBAR_NAV_SECTIONS, flattenSidebarNavItems } from "@/config/sidebarNav";
import {
  deriveWorkspacePersona,
  getSidebarSectionsForPersona,
  type WorkspacePersona,
} from "@/config/workspacePersona";
import type { ToolAccessRow } from "@/types/systemAdmin";

const PERSONA_COLUMNS: { id: WorkspacePersona; label: string }[] = [
  { id: "leader", label: "Leader" },
  { id: "district_leader", label: "District leader" },
  { id: "teacher", label: "Teacher" },
  { id: "support_staff", label: "Support staff" },
  { id: "classified_staff", label: "Classified staff" },
];

const personaHasNavItem = (persona: WorkspacePersona, itemId: string): boolean => {
  const sections = getSidebarSectionsForPersona(persona);
  return sections.some((section) => section.items.some((item) => item.id === itemId));
};

/** Sidebar tools × workspace persona — what each persona sees in navigation. */
export function buildToolAccessMatrix(): ToolAccessRow[] {
  const rows: ToolAccessRow[] = [];

  for (const section of SIDEBAR_NAV_SECTIONS) {
    for (const item of flattenSidebarNavItems(section.items)) {
      const accessByPersona: Record<string, boolean> = {};
      for (const col of PERSONA_COLUMNS) {
        accessByPersona[col.id] = personaHasNavItem(col.id, item.id);
      }

      rows.push({
        toolId: item.id,
        label: item.label,
        section: section.label,
        pathOrEntry: item.kind === "link" ? item.to : `chat:${item.entry}`,
        accessByPersona,
      });
    }
  }

  return rows;
}

export { PERSONA_COLUMNS };

export function formatPersonaLabel(persona: string | null | undefined): string {
  const derived = deriveWorkspacePersona({ workspace_persona: persona ?? null });
  const match = PERSONA_COLUMNS.find((c) => c.id === derived);
  return match?.label ?? derived;
}
